class DVSearchModalController {
    constructor() {
        this.$onInit = () => {
            this.state = {
                advancedQuery: '',
                advancedQueryContains: false,
                dvFailedTraces: false
            };
            const traceSummaryRequest = this.resolve.traceSummaryRequest;
            if (traceSummaryRequest !== undefined) {
                if (traceSummaryRequest.advancedQuery) {
                    this.state.advancedQuery = traceSummaryRequest.advancedQuery;
                }
                if (traceSummaryRequest.advancedQueryContains !== undefined) {
                    this.state.advancedQueryContains = traceSummaryRequest.advancedQueryContains;
                }
                if (traceSummaryRequest.DVFailedTraces !== undefined) {
                    this.state.dvFailedTraces = traceSummaryRequest.DVFailedTraces;
                }
            }
        };
        this.ok = () => {
            let traceSummaryRequest = {
                advancedQuery: this.state.advancedQuery,
                advancedQueryContains: this.state.advancedQueryContains,
                DVFileOnly: true, // hard coded just now
                DVFailedTraces: this.state.dvFailedTraces
            };
            this.close({ $value: traceSummaryRequest }).result;
        };
        this.cancel = () => {
            this.dismiss({ $value: '' });
        };
        this.clear = () => {
            this.state.advancedQuery = '';
            this.state.advancedQueryContains = false;
            this.state.dvFailedTraces = false;
        };
    }
}
angular.module('app').component('dvSearchModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/DataValidator/dv-search-modal.tpl.html',
    controllerAs: 'vm',
    controller: DVSearchModalController
});
